import PubSub from "pubsub-js";
import { eventNames } from "../constants/eventNames";

export class LoaderService {
  static show(): void {
    PubSub.publish(eventNames.showLoader);
  }

  static hide(): void {
    PubSub.publish(eventNames.hideLoader);
  }

  static showTreeComLoading(): void {
    PubSub.publish(eventNames.showTreeComLoader);
  }

  static hideTreeComLoading(): void {
    PubSub.publish(eventNames.hideTreeComLoader);
  }
}
